export default function cosineSimilarity(embedding1, embedding2) {
  let dotProduct = 0
  let norm1 = 0
  let norm2 = 0

  for (let i = 0; i < embedding1?.length; i++) {
    dotProduct += embedding1?.[i] * embedding2?.[i]
    norm1 += embedding1?.[i] * embedding1?.[i]
    norm2 += embedding2?.[i] * embedding2?.[i]
  }

  norm1 = Math.sqrt(norm1)
  norm2 = Math.sqrt(norm2)

  if (norm1 === 0 || norm2 === 0) {
    return 0 // Avoid division by zero
  }

  return dotProduct / (norm1 * norm2)
}
